import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "detereco_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/auth/login`, { password });
  setToken(data.token);
  return data;
};

export const adminCheck = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
  return data;
};

export const adminCreateProduct = async (payload) => {
  const { data } = await axios.post(`${API}/admin/products`, payload, { headers: authHeaders() });
  return data;
};

export const adminUpdateProduct = async (id, payload) => {
  const { data } = await axios.put(`${API}/admin/products/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const adminDeleteProduct = async (id) => {
  const { data } = await axios.delete(`${API}/admin/products/${id}`, { headers: authHeaders() });
  return data;
};

export const adminListReviews = async () => {
  const { data } = await axios.get(`${API}/admin/reviews`, { headers: authHeaders() });
  return data;
};

export const adminDeleteReview = async (id) => {
  const { data } = await axios.delete(`${API}/admin/reviews/${id}`, { headers: authHeaders() });
  return data;
};

export const adminCreateReview = async (productId, payload) => {
  const { data } = await axios.post(`${API}/admin/reviews?product_id=${productId}`, payload, { headers: authHeaders() });
  return data;
};

export const adminListOrders = async () => {
  const { data } = await axios.get(`${API}/admin/orders`, { headers: authHeaders() });
  return data;
};

export const adminUpdateOrderCustomer = async (orderId, customer) => {
  const { data } = await axios.put(`${API}/admin/orders/${orderId}/customer`, customer, { headers: authHeaders() });
  return data;
};

export const adminGenerateAwb = async (orderId) => {
  const { data } = await axios.post(`${API}/admin/orders/${orderId}/cargus-awb`, {}, { headers: authHeaders() });
  return data;
};

export const adminDownloadAwb = async (orderId, barcode) => {
  const res = await axios.get(`${API}/admin/orders/${orderId}/cargus-awb.pdf`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `AWB-${barcode}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const adminGenerateInvoice = async (orderId) => {
  const { data } = await axios.post(`${API}/admin/orders/${orderId}/invoice`, {}, { headers: authHeaders() });
  return data;
};

export const adminDownloadInvoice = async (orderId, label) => {
  const res = await axios.get(`${API}/admin/orders/${orderId}/invoice.pdf`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `Factura-${label}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const adminSaveSettings = async (payload) => {
  const { data } = await axios.put(`${API}/settings`, payload, { headers: authHeaders() });
  return data;
};

export const adminUploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/admin/upload`, form, {
    headers: authHeaders(),
  });
  return data; // { url, path }
};

// Resolve relative /api/files/... urls to absolute for display
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return `${backend}${url}`;
};
